import Color from 'color';
import styled from 'styled-components';

import InfoSVG from '../../../../../../assets/icons/primary/Info Circle.svg';
import {getColor, ms, square} from '../../../../../../styles';
import {Text} from '../../../../../../uikit/Text';
import {View} from '../../../../../../uikit/View';

export const Container = styled(View)`
  min-height: ${ms(40)};
  align-items: center;
  padding-inline: ${ms(12)};
  padding-block: ${ms(6)};
  gap: ${ms(8)};
  border-radius: ${ms(8)};
  background-color: ${p => Color(getColor('error')(p)).alpha(0.1).toString()};
  flex: 1;
`;

export const Message = styled(Text).attrs({
  color: 'error',
})`
  flex: 1;
`;

export const InfoIcon = styled(InfoSVG).attrs(p => ({
  fill: getColor('error')(p),
}))`
  ${square(24)};
`;
